import { useAtomValue, useSetAtom } from 'jotai';
import { showFailureToast, showSuccessToast } from 'lib/ToastHelper';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from 'reactstrap';
import { companyIdAtom } from 'views/state';

import { updateIntegrationLabel } from '../../services/integrationListingService';
import { updateIntegrationRowAtom } from '../../state';
import { IntegrationItem } from '../../types/integrationListing.types';

interface UpdateAliasModalProps {
  isOpen: boolean;
  toggle: () => void;
  row: IntegrationItem;
}

const UpdateAliasModal: React.FC<UpdateAliasModalProps> = ({
  isOpen,
  toggle,
  row,
}) => {
  const companyId = useAtomValue(companyIdAtom);
  const updateIntegrationRow = useSetAtom(updateIntegrationRowAtom);

  const [alias, setAlias] = useState('');
  const originalAlias = row.integration_label || '';

  useEffect(() => {
    if (isOpen) {
      setAlias(originalAlias);
    }
  }, [isOpen, originalAlias]);

  async function confirmAliasModal() {
    toggle();
    await updateIntegrationLabel(row.id, alias.trim(), companyId)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          updateIntegrationRow({
            id: row.id,
            data: { integration_label: alias.trim() },
          });
          showSuccessToast('Integration label updated successfully.');
        } else {
          showFailureToast(
            'Failed to update integration label. Please try again.',
          );
        }
      })
      .catch((err) => {
        let error = 'Error occurred. Please try again.';
        if (err?.data?.detail) {
          if (err.data.detail.includes('duplicate')) {
            error =
              'An integration label with the same name is already assigned. Please choose a different name.';
          } else {
            error = err.data.detail;
          }
        }
        showFailureToast(error);
      });
  }

  return (
    <Modal isOpen={isOpen} size="lg" toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Integration Label</ModalHeader>
      <ModalBody>
        <Table className="tablesorter table-striped" responsive>
          <tbody>
            <tr>
              <td>Integration Label</td>
              <td>
                <Input
                  type="text"
                  value={alias}
                  placeholder="Label (Max length 100 characters)"
                  maxLength={100}
                  onChange={(e) => setAlias(e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => void confirmAliasModal()}
          disabled={
            alias.trim() === originalAlias.trim() || alias.trim() === ''
          }
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateAliasModal;
